import { BadgeMap } from 'components/ComposableTable/generators/TextBadgeCell';

export const statusToTextBadge: BadgeMap = {
  draft: {
    textColor: 'whiteout',
    color: 'graphite',
  },
  inactive: {
    textColor: 'whiteout',
    color: 'pencil',
  },
  active: {
    textColor: 'whiteout',
    color: 'atlas',
  },
};
